module.exports = __webpack_public_path__ + "8b90fcc2b6f5e6d71d86f3a05133b481.svg";